export default __webpack_public_path__ + "static/media/location_ruka.c81d3afd.jpg";